var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.031,
    height: 31.062,
    viewBox: "0 0 31.031 31.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(-1177.471 -568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M108.917,93.249a2.2,2.2,0,0,1-2.223,2.191H89.1a2.2,2.2,0,0,1-2.223-2.191V75.593A2.219,2.219,0,0,1,89.1,73.4h8.992l2.845-2.845H89.1A5.073,5.073,0,0,0,84,75.593V93.249a5.079,5.079,0,0,0,5.1,5.068h17.624a5.079,5.079,0,0,0,5.1-5.068V81.38l-2.845,2.845v9.024Z",
    transform: "translate(1093.469 500.745)",
    fill: "#431cc4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M236.692,18.643,232.7,14.687A2.311,2.311,0,0,0,231.1,14a2.223,2.223,0,0,0-1.6.654L214.785,29.368a2.261,2.261,0,0,0-.654,1.471l-.262,4.218a2.337,2.337,0,0,0,.654,1.766,2.277,2.277,0,0,0,1.6.654h.131l4.251-.261a2.261,2.261,0,0,0,1.471-.654L236.659,21.88a2.277,2.277,0,0,0,.654-1.6,2.143,2.143,0,0,0-.621-1.635ZM227.308,20.9l3.172,3.172-7.357,7.324-3.172-3.172Zm-7.193,13.5-3.368.2.2-3.368.948-.948,3.172,3.172Zm12.359-12.392-3.139-3.139,1.766-1.766,3.172,3.172Z",
    transform: "translate(971.187 554)",
    fill: "#431cc4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ea48a0dc.svg";
export { ForwardRef as ReactComponent };